module.exports = __webpack_public_path__ + "img/ge.7e936548.png";